var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section", attrs: { id: "informations" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "section-body" }, [
      _c("textarea", {
        attrs: { name: "description", rows: "5" },
        domProps: { value: _vm.information },
        on: {
          input: function($event) {
            return _vm.setInformation($event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "radio-product",
          class: { checked: _vm.use_my_products },
          on: {
            click: function($event) {
              return _vm.setUseMyProducts(!_vm.use_my_products)
            }
          }
        },
        [_vm._v("Desejo usar os produtos que tenho em casa.")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.use_my_products,
              expression: "!use_my_products"
            }
          ],
          staticClass: "quote"
        },
        [_vm._v("ao marcar esta opção, o profissional não levará os produtos.")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("INFORMAÇÕES SOBRE A LIMPEZA\n    "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-792b5547", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-792b5547","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/Informations.vue
// module id = null
// module chunks = 